// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__iX8ul","select":"styles_select__2IW7P"};